import React from "react";

export default function GestureButton({ action, label, emoji, activeAction, onTrigger, className = "" }) {
  const isActive = activeAction === action;
  const handleClick = () => {
    if (typeof onTrigger === 'function') onTrigger(action);
  };
  const handleKeyDown = (e) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      handleClick();
    }
  };
  return (
    <div className={`lrp-gesture-item ${className}`.trim()} role="button" tabIndex={0} onClick={handleClick} onKeyDown={handleKeyDown}>
      <svg
        className={`lrp-gesture-svg${isActive ? ' is-active' : ''}`}
        data-action={action}
        width="40" height="40" viewBox="0 0 40 40" role="img" aria-label={`${label}`}>
        <rect x="0" y="0" width="40" height="40" rx="8" ry="8" fill="rgba(0,0,0,0.45)" stroke="rgba(255,255,255,0.25)" />
        <text x="50%" y="50%" textAnchor="middle" dominantBaseline="central" fontSize="22">{emoji}</text>
      </svg>
      <div className="lrp-gesture-caption">{label}</div>
    </div>
  );
}
